import Cookies from 'js-cookie'
const account = {
  state: {
    token: Cookies.get('default_auth_token') || null,
    accountId: Cookies.get('accountId') || null,
    account: null,
    user: JSON.parse(localStorage.getItem('user') || null) || null,
    country: Cookies.get('country') || null,
    portalVersion: Cookies.get('portalVersion') || null,
    currentLocale: Cookies.get('currentLocale') || 'en-IN',
    email: null,
    userType: Cookies.get('user_type') || null,
    userTarget: Cookies.get('user_target') || null
  },
  getters: {
    ddpCheck: (state) => {
      if (state.account) {
        return state.account.credit_limit
      }
    },
    hasPermission: (state) => (hasPermission) => {
      if (
        state.account &&
        state.account.parent_user_permissions &&
        state.account.parent_user_permissions.access_roles
      ) {
        return (
          state.account.parent_user_permissions.access_roles.indexOf(
            hasPermission
          ) > -1
        )
      }
    },
    hasActionPermission: (state) => (entity, action) => {
      if (state.user && state.user.portal_access_roles) {
        if (entity in state.user.portal_access_roles) {
          return state.user.portal_access_roles[entity].actions.includes(action)
        }
      }
      return false
    },
    hasInvoiceAddAndCreatePermission: (state) => () => {
      if (state.user && state.user.portal_access_roles) {
        if ('invoice' in state.user.portal_access_roles) {
          const invoice = state.user.portal_access_roles['invoice']
          return (
            invoice.actions.includes('create') &&
            invoice.actions.includes('update')
          )
        }
      }
      return false
    },
    npsEnabled: (state) => {
      if (state.account) {
        return state.account.parent_user_permissions.nps_roles.esign_nps_enabled
      }
    },
    npsSurveyId: (state) => {
      if (state.account) {
        return state.account.parent_user_permissions.nps_roles
          .esign_nps_survey_id
      }
    },
    accountId: (state) => state.accountId,
    userId: (state) => state.userId,
    token: (state) => state.token,
    user: (state) => state.user
  },
  mutations: {
    SET_ACCOUNT_ID: (state, data) => {
      Cookies.set('accountId', data.id)
      state.accountId = data.id
    },
    SET_ACCOUNT: (state, data) => {
      Cookies.set('country', data.account.country)
      Cookies.set('portalVersion', data.account.portal_version)
      state.account = data.account
      state.country = data.account.country
      state.portalVersion = data.account.portal_version
    },
    UNSET_ACCOUNT_ID: (state) => {
      Cookies.remove('accountId')
      state.accountId = null
    },
    UNSET_ACCOUNT: (state) => {
      const removeDomainSpecificCookies = (item) => {
        Cookies.remove(item, {
          domain: '.dripcapital.com'
        })
      }
      const removeCookies = (item) => {
        Cookies.remove(item)
      }
      const cookieItems = [
        'account',
        'accountId',
        'country',
        'name',
        'email',
        'currentLocale',
        'portalVersion',
        'user_type',
        'userId',
        'user_id',
        'user_target',
        'rememberMe',
        'default_auth_token',
        'token'
      ]
      cookieItems.forEach((item) => {
        removeDomainSpecificCookies(item)
        removeCookies(item)
      })
      localStorage.removeItem('default_auth_token')
      localStorage.removeItem('user')
      state.account = null
      state.country = null
      state.portalVersion = null
      state.token = null
      state.userId = null
      state.user = null
    },
    SET_LOCALE: (state, data) => {
      state.currentLocale = data
      Cookies.set('currentLocale', data)
    },
    UNSET_LOCALE: (state, data) => {
      state.currentLocale = data
      Cookies.set('currentLocale', data)
    },
    SET_EMAIL: (state, data) => {
      state.email = data
    },
    UPDATE_ESIGN: (state, data) => {
      state.account.legal_agreements_esigned = data
    },
    SET_USER_TYPE: (state, data) => {
      state.userType = data.utype
      state.userTarget = data.target
      state.token = data.message && data.message.token
      Cookies.set('user_type', state.userType, { domain: '.dripcapital.com' })
      Cookies.set('user_target', state.userTarget, {
        domain: '.dripcapital.com'
      })
    },
    SET_USER: (state, data) => {
      state.user = data
      state.email = data && data.email
    },
    SET_DRIP_SWITCH_USER_LEVEL_CONFIG: (state, data) => {
      if (state.account) {
        state.account.drip_switch_enabled = data
      }
    }
  },
  actions: {
    setAccountId({ commit }, data) {
      commit('SET_ACCOUNT_ID', data)
    },
    setAccount({ commit }, data) {
      commit('SET_ACCOUNT', data)
    },
    unsetAccountId({ commit }) {
      commit('UNSET_ACCOUNT_ID')
      commit('UNSET_ACCOUNT')
    },
    setLocale({ commit }, data) {
      commit('SET_LOCALE', data)
    },
    unsetLocale({ commit }) {
      commit('UNSET_LOCALE', 'en-IN')
    },
    setEmail({ commit }, data) {
      commit('SET_EMAIL', data)
    },
    setEsignStatus({ commit }, data) {
      commit('UPDATE_ESIGN', data)
    },
    setUserType({ commit }, data) {
      commit('SET_USER_TYPE', data)
    },
    setUser({ commit }, data) {
      commit('SET_USER', data)
    },
    setDripSwitchUserLevel({ commit }, data) {
      commit('SET_DRIP_SWITCH_USER_LEVEL_CONFIG', data)
    }
  }
}

export default account
